import { action } from 'typesafe-actions';

import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { IAdminCatalogForUpdate } from 'APIPackage/AdminModule/interfaces/IAdminCatalogForUpdate';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { INews } from 'APIPackage/NewsModule/interfaces/INews';
import { IActionAboveUser, IManageTestUser } from 'APIPackage/ManageTestUserModule/interface/IManageTestUser';
import {
  ISystemInoperability,
  ISystemInoperabilityFormRef,
} from 'APIPackage/SystemInoperabilityModule/interfaces/ISystemInoperability';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';

import { AdminActionsEnum } from '../enums/AdminActionsEnum';
import { ChangeCatalog } from '../types/ChangeCatalog';
import { IExportForm } from '../interfaces/IExportForm';
import { ISmevResend } from '../../../APIPackage/ControlIfNewsletterModule/interfaces/ISmevResend';

export const adminGetUserAdminUrl = () => action(AdminActionsEnum.ADMIN_GET_USER_ADMIN_URL);
export const adminSetUserAdminUrl = (userAdminUrl: string) =>
  action(AdminActionsEnum.ADMIN_SET_USER_ADMIN_URL, { userAdminUrl });
export const adminGetFetchSettings = (force = false) => action(AdminActionsEnum.ADMIN_GET_FETCH_SETTINGS, { force });
export const adminGetFetchSettingsSuccess = (settings: IAdminSetting[]) =>
  action(AdminActionsEnum.ADMIN_GET_FETCH_SETTINGS_SUCCESS, { settings });
export const adminSetFetchSettings = (settings: IAdminSetting[]) =>
  action(AdminActionsEnum.ADMIN_SET_FETCH_SETTINGS, { settings });
export const adminUpdateSettings = (body: IAdminSetting, id: string | number) =>
  action(AdminActionsEnum.ADMIN_UPDATE_SETTINGS, { body, id });
export const adminUpdateSettingsSchedule = (body: IAdminSetting[]) =>
  action(AdminActionsEnum.ADMIN_UPDATE_SETTINGS_SCHEDULE, { body });
export const adminGetCatalogsForUpdate = () => action(AdminActionsEnum.ADMIN_GET_CATALOGS_FOR_UPDATE);
export const adminSetCatalogsForUpdate = (catalogs: IAdminCatalogForUpdate[]) =>
  action(AdminActionsEnum.ADMIN_SET_CATALOGS_FOR_UPDATE, { catalogs });
export const adminUploadCatalogs = (id: number, file: File) =>
  action(AdminActionsEnum.ADMIN_UPLOAD_CATALOGS, { id, file });
export const adminGetCatalogTypes = (catalogName: CommonCatalogsNamesEnum) =>
  action(AdminActionsEnum.ADMIN_GET_CATALOG_TYPES, { catalogName });
export const adminCreateCatalogTypes = (params: ChangeCatalog<'id'>) =>
  action(AdminActionsEnum.ADMIN_CREATE_CATALOG_TYPES, { params });
export const adminUpdateCatalogTypes = (params: ChangeCatalog) =>
  action(AdminActionsEnum.ADMIN_UPDATE_CATALOG_TYPES, { params });
export const adminSetCatalogName = (catalogName?: CommonCatalogsNamesEnum) =>
  action(AdminActionsEnum.ADMIN_SET_CATALOG_NAME, { catalogName });
export const adminUpdateFrgu = () => action(AdminActionsEnum.ADMIN_UPDATE_FRGU);
export const adminGetNews = () => action(AdminActionsEnum.ADMIN_GET_NEWS);
export const adminGetNewsNextPage = () => action(AdminActionsEnum.ADMIN_GET_NEWS_NEXT_PAGE);
export const adminSetNews = (news: INews[], newsPage: number, newsPageCount: number, newsTotalCount: number) =>
  action(AdminActionsEnum.ADMIN_SET_NEWS, { news, newsPage, newsPageCount, newsTotalCount });
export const adminSetNewsOrder = (order: string) => action(AdminActionsEnum.ADMIN_SET_NEWS_ORDER, { order });
export const adminCatalogsExportsSubmit = (data: IExportForm, settings: IAdminSetting[]) =>
  action(AdminActionsEnum.ADMIN_CATALOGS_EXPORTS_SUBMIT, { data, settings });

export const adminGetSystemInoperabilityList = () => action(AdminActionsEnum.ADMIN_GET_SISTEM_INOPERABILITY_LIST);

export const adminSetSystemInoperabilityListShowSave = (isShowSave: boolean) =>
  action(AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST_SHOW_SAVE, {
    systemInoperabilityListShowSave: isShowSave,
  });

export const adminSetSystemInoperabilityListDisableSave = (isDisableSave: boolean) =>
  action(AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST_DISABLE_SAVE, {
    systemInoperabilityListDisableSave: isDisableSave,
  });

export const adminSetSystemInoperabilityAddRecord = (formData: ISystemInoperability[]) =>
  action(AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST_ADD_RECORD, formData);

export const adminGetSystemInoperabilityListNextPage = () =>
  action(AdminActionsEnum.ADMIN_GET_SISTEM_INOPERABILITY_LIST_NEXT_PAGE);

export const adminSetSystemInoperabilityListOrder = (order: string) =>
  action(AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST_ORDER, { order });

export const adminSetSystemInoperabilityList = (
  systemInoperabilityList: ISystemInoperability[],
  systemInoperabilityListPage: number,
  systemInoperabilityListPageCount: number,
  systemInoperabilityListTotalCount: number,
) => {
  return action(AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST, {
    systemInoperabilityList,
    systemInoperabilityListPage,
    systemInoperabilityListPageCount,
    systemInoperabilityListTotalCount,
  });
};

export const adminSetSystemInoperabilityFormUnsavedRecords = (unsavedRecords: ISystemInoperability[]) =>
  action(AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_FORM_UNSAVED_RECORDS, { unsavedRecords });

export const adminSetSystemInoperabilityFormRef = (systemInoperabilityFormRef: ISystemInoperabilityFormRef) =>
  action(AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_SET_FORM_REF, { systemInoperabilityFormRef });

export const adminSetSystemInoperabilityFormElementRef = (systemInoperabilityFormElementRef: HTMLFormElement | null) =>
  action(AdminActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_SET_FORM_ELEMENT_REF, { systemInoperabilityFormElementRef });

export const adminGetSmevResendBySendingDate = (startDate: Date, endDate: Date) =>
  action(AdminActionsEnum.ADMIN_GET_SMEV_RESEND_BY_SENDING_DATE, { startDate, endDate });

export const adminGetSmevResendBySendingDateNextPage = (startDate: Date, endDate: Date) =>
  action(AdminActionsEnum.ADMIN_GET_SMEV_RESEND_BY_SENDING_DATE_NEXT_PAGE, { startDate, endDate });

export const adminSetSmevResendBySendingDateList = (
  controlOfNewslettersList: ISmevResend[],
  controlOfNewslettersListPage: number,
  controlOfNewslettersListTotalCount: number,
) => {
  return action(AdminActionsEnum.ADMIN_SET_SMEV_RESEND_BY_SENDING_DATE, {
    controlOfNewslettersList,
    controlOfNewslettersListPage,
    controlOfNewslettersListTotalCount,
  });
};

export const adminGetManageTestUsersList = (username?: string, fullName?: string) =>
  action(AdminActionsEnum.ADMIN_GET_MANAGE_TEST_USERS_LIST, { username, fullName });
export const adminGetManageTestUsersListNextPage = (username?: string, fullName?: string) =>
  action(AdminActionsEnum.ADMIN_GET_MANAGE_TEST_USERS_LIST_NEXT_PAGE, { username, fullName });
export const adminSetManageTestUsersListOrder = (order: string) =>
  action(AdminActionsEnum.ADMIN_SET_MANAGE_TEST_USERS_LIST_ORDER, { order });
export const adminSetManageTestUsersList = (
  mangeTestUsersList: IManageTestUser[],
  mangeTestUsersListPage: number,
  mangeTestUsersListPageCount: number,
  mangeTestUsersListTotalCount: number,
) => {
  return action(AdminActionsEnum.ADMIN_SET_MANAGE_TEST_USERS_LIST, {
    mangeTestUsersList,
    mangeTestUsersListPage,
    mangeTestUsersListPageCount,
    mangeTestUsersListTotalCount,
  });
};
export const adminUpdateManageTestUsersList = (list: IActionAboveUser[], username?: string, fullName?: string) =>
  action(AdminActionsEnum.ADMIN_UPDATE_MANAGE_TEST_USERS_LIST, { list, username, fullName });

export const setImmediateTestPurchase = (days: number, settings: IAdminSetting[]) => {
  const existingSetting = settings.find(setting => setting.code === AdminSettingCodesEnum.IMMEDIATE_TEST_PURCHASE_DAYS);

  return action(AdminActionsEnum.ADMIN_UPDATE_SETTINGS, {
    id: existingSetting?.id,
    body: {
      id: existingSetting?.id,
      code: AdminSettingCodesEnum.IMMEDIATE_TEST_PURCHASE_DAYS,
      value: days.toString(),
      description: existingSetting?.description,
      periods: existingSetting?.periods,
    },
  });
};
